// Copyright (c) 2015, Mightium Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

// for translation
mightium._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = mightium._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = mightium._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = mightium._;

mightium.get_languages = function () {
	if (!mightium.languages) {
		mightium.languages = [];
		$.each(mightium.boot.lang_dict, function (lang, value) {
			mightium.languages.push({ label: lang, value: value });
		});
		mightium.languages = mightium.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return mightium.languages;
};
